/** @format */

import { Lesson, UserResource } from "../../../features/resources/types";
import { api } from "../api";
import { SaveUserResourceBody } from "./userResourcesApi";

export const userLessonApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserResourceLesson: build.query<
      Lesson,
      {
        code: string;
        locale: string;
        copy: string;
        email: string;
        lessonIndex: number;
      }
    >({
      query: ({ code, locale, copy, email }) =>
        `user-resource/get/${code}/${locale}/${copy}/${email}`,
      transformResponse: (
        response: { userResource: UserResource },
        meta: undefined,
        { lessonIndex },
      ) => response.userResource?.Object?.lessons?.[lessonIndex],
      providesTags: (result) => [{ type: "SubLesson", id: result?.uuid }],
    }),

    saveUserLesson: build.mutation<UserResource, SaveUserResourceBody>({
      query(body) {
        return {
          url: "user-resource/save-resource",
          method: "POST",
          body,
        };
      },
      transformResponse: (response: { resource: UserResource }) =>
        response.resource,
      invalidatesTags: [
        "SubLesson",
        "Card",
        "Resource", // TODO: REMOVE AT LATER DATE
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useSaveUserLessonMutation, useGetUserResourceLessonQuery } =
  userLessonApi;
